<template>
	<apexchart :width="width" :height="height" :options="options" :series="parsedData" />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "InfoCard",
	props: {
		seriesTitle: {
			type: String
		},
		seriesColor: {
			type: String
		},
		title: {
			type: String
		},
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "100%",
		},
		loading: {
			type: Boolean,
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	components: {
		apexchart: VueApexCharts,
	},
	data: function () {
		return {};
	},
	computed: {
		parsedData(){
			return [
				{
					name: "",
					data: this.seriesArray
				}
			]
		},
		tooltipLabels() {
			if(!this.data || !this.data.period) return [];
  			const keys = Object.keys(this.data.period);
  			const values = Object.values(this.data.period);
  			return keys.map((k, i) => `${k}: ${values[i]}`);
		},
		seriesArray(){
			if(!this.data || !this.data.period) return [];
			if(Object.keys(this.data.period).length){
				return Object.values(this.data.period)
			}

			return [];
		},
		totalValue(){
			if(!this.data) return [];
			if(Object.keys(this.data).length){
				return this.data.total
			}

			return []
		},
		options() {
			return {
				chart: {
					type: 'area',
					height: 160,
					sparkline: {
						enabled: true
					},
				},
				stroke: {
					curve: 'smooth'
				},
				fill: {
					opacity: 0.3,
				},
				yaxis: {
					min: 0,
					labels: {
						show: false
					}
				},
				xaxis: {
				  categories: Object.keys(this.data?.period || {}),
				  labels: {
				    show: true
				  }
				},
				colors: [this.seriesColor],
				title: {
					text: this.totalValue,
					offsetX: 0,
					style: {
						fontSize: '16px',
					}
				},
				subtitle: {
					text: this.seriesTitle,
					offsetX: 0,
					style: {
						fontSize: '14px',
					}
				},
				tooltip: {
				  y: {
				    formatter: (value, { dataPointIndex }) => {
				      return value;
				    }
				  },
				  title: {
				    formatter: () => ""
				  }
				}
			};
		},
	},
};
</script>

<style lang="scss" scoped></style>